import apiUrl from '../../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
//import VueElementLoading from 'vue-element-loading';
import {BasicSelect,  MultiSelect} from 'vue-search-select'
import vueMultiSelect from 'vue-multi-select';
import 'vue-multi-select/dist/lib/vue-multi-select.css';
import MasterService from './../../../services/masterdata.service';
import Loader from '../../../../shared/components/loader'

export default {
  name: 'serviceareatemplate',
  props:
    ['selectedServiceArea', 'zoneListArray','Loading'],

  components: {
    //VueElementLoading,
    Paginate,
    BasicSelect,
    vueMultiSelect,
    Loader
  },
  data: function() {
    return {
      serviceDescription: '',
      userName: '',
      isLoading:false,
      updateID: '',
      length: '',
      serviceAreaName: '',
      zoneList: [{
        zoneListArr: []
      }],
      btnLabel: values => `Territory Name`,
      filters: [],
      options: {
        multi: true,
        groups: true,
        labelName: 'cargozonename',
        labelList: 'zoneListArr',
        groupName: 'action',
        width: '200px',
        cssSelected: option => (option.selected ? {
          'background-color': 'gray'
        } : ''),
      },
      selectedZone: [],
      zoneselection: ''
    }
  },
  computed: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.setZoneList();
  },
  methods: {
    onChange(){
      if(this.selectedZone.length>0){
        this.zoneselection = this.selectedZone.length;
      }else{
        this.zoneselection = "";
      }
    },
    setZoneList(){
      this.zoneList[0].zoneListArr = this.zoneListArray;
      if(this.selectedServiceArea){
        this.updateServiceAreaForm();
      } else {
        this.updateID = null;
        this.serviceDescription = "";
        this.serviceAreaName = "";
        this.selectedZone = []
      }
    },
    updateServiceAreaForm(){
      this.updateID = this.selectedServiceArea.id;
      this.serviceDescription = this.selectedServiceArea.serviceareadescription;
      this.serviceAreaName = this.selectedServiceArea.serviceareaname;
      this.selectedZone = this.zoneListArray.filter((el)=>{
        let obj = this.selectedServiceArea.serviceareadetails.find(obj => obj.assignedzone == el.id);
        if(obj){
          return true;
        } else {
          return false
        }
      })
    },
    showCreateServiceArea() {
      this.$emit("goBackToParent")
    },
    async createServiceArea(serviceArea){
      try {
        var inputPayload = {};
        this.isLoading = true;
        if(this.updateID){
          inputPayload.serviceareaid = this.updateID;
        }
        inputPayload.serviceareaname = this.serviceAreaName.trim(),
        inputPayload.serviceareadescription = this.serviceDescription.trim(),
        inputPayload.assignedzone = this.selectedZone.map(el=> el.id),
        inputPayload.lastmodifiedby = this.userName

        let result = await MasterService.createServiceArea(inputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
          this.$alert(result.data.message, this.serviceAreaName, "success");
          this.$emit("goBackToParent");
        }else{
          this.$alert(result.data.message, this.serviceAreaName, "error");
        }
      } catch(err){
        this.isLoading = false;
        this.$alert(err, this.serviceAreaName, "error");
        console.log(err);
      }
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.createServiceArea(event);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/ServiceAreaTemplate/createServiceAreaTemplate/createServiceAreaTemplate.component.js